import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { LoginComponent } from './pages/iniciar-sesion/login.component';
import { SignupComponent } from './pages/registro/signup.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HomeComponent } from './pages/home/home.component';
import { ErrorInterceptor } from './shared/error.interceptor';
import { AuthInterceptor } from './shared/auth/auth.interceptor';
import { UsersComponent } from './pages/usuarios/list/users.component';
import { EditUserComponent } from './pages/usuarios/edit-user/edit-user.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { EditPlatoComponent } from './pages/platos/edit-plato/edit-plato.component';
import { ListPlatosComponent } from './pages/platos/list-platos/list-platos.component';
import { NgbModule, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { NavElementsComponent } from './shared/nav-elements/nav-elements.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { DragulaModule } from 'ng2-dragula';
import { ListIngredientesCondimentosComponent } from './pages/platos/list-ingredientes-condimentos/list-ingredientes-condimentos.component';
import { ListNeverasComponent } from './pages/neveras/list-neveras/list-neveras.component';
import { EditNeverasComponent } from './pages/neveras/edit-neveras/edit-neveras.component';
import { EditVestidosComponent } from './pages/vestidos/edit-vestidos/edit-vestidos.component';
import { ConfirmDeactivateGuardGuard } from './shared/confirm-deactivate-guard.guard';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    LoginComponent,
    SignupComponent,
    HomeComponent,
    UsersComponent,
    EditUserComponent,
    NotFoundComponent,
    EditPlatoComponent,
    ListPlatosComponent,
    SidebarComponent,
    NavElementsComponent,
    SpinnerComponent,
    ListIngredientesCondimentosComponent,
    ListNeverasComponent,
    EditNeverasComponent,
    EditVestidosComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    RouterModule,
    HttpClientModule,
    NgbModule,
    DragulaModule.forRoot(),
    NgbToastModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ConfirmDeactivateGuardGuard,
    { provide: Window, useValue: window },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
